const NAMES: Record<number, string> = {
  1: 'Unsatisfactory',
  2: 'Basic',
  3: 'Proficient',
  4: 'Distinguished',
}

interface LevelBadgeProps {
  level: number
  short?: boolean
}

export function LevelBadge({ level, short = false }: LevelBadgeProps) {
  const cls = level > 0 ? `badge-lvl lvl${level}` : 'badge-lvl lvl0'
  return (
    <span className={cls}>
      {level > 0 ? (short ? level : `${level} — ${NAMES[level]}`) : '—'}
    </span>
  )
}
